/* eslint-disable @typescript-eslint/naming-convention */
import { DynamicObjectInterface, PublishDetailsType } from '../types';

export interface GetFindOutMoreData {
  title: string;
  image: ImageReturnType;
  findOutMoreDescription: string;
}

// Transformed Format
interface ProfileImagesDataType {
  title?: string;
  locale?: string;
  signUpCustomer: {
    customerImage: ImageReturnType;
    ABOImage: ImageReturnType;
  };
  profileComplete: {
    image: ImageReturnType;
    title?: string;
    desc?: string;
    subTitle?: string;
  };
  selectSponsor: {
    internationalSponsorTnc1?: string;
    internationalSponsorTnc2?: string;
  };
  noRecordImage: ImageReturnType;
  googleIcon: ImageReturnType;
  facebookIcon: ImageReturnType;
  passportLoading: ImageReturnType;
  personalDetailsDesktopImage: ImageReturnType;
  sampleCid: ImageReturnType;
  sampleCidBack?: ImageReturnType;
  samplePassport: ImageReturnType;
  cidLoading: ImageReturnType;
  coApp?: CoAppFormattedType;
  accountCardImage: ImageReturnType;
  accountUpgradeImage: ImageReturnType;
}
interface AccountTypeImagesType {
  locale?: string;
  landingPageImage?: ImageReturnType[];
  idVerificationImage?: ImageReturnType[];
  findoutMoreImage?: ImageReturnType[];
  personalDetailsImage?: ImageReturnType;
  user_account?: { user_account?: string };
}
interface RegistrationTermsConditionType {
  locale?: string;
  termsAndConditions?: string;
  landingPageDetails?: string;
  findoutMorePageDetails?: string;
  user_account?: { user_account?: string };
}

interface TermsConditionType {
  title?: string;
  description: string;
}
interface AccountLifeCycleCMSType {
  title: string;
  locale?: string;
  renewalCardImage: ImageReturnType;
  upgradeScreenImage: ImageReturnType;
  upgradeDesktopImage: ImageReturnType;
  renewalTermsCondition?: TermsConditionType;
  upgradeTermsCondition?: TermsConditionType;
  downgradeTermsCondition?: TermsConditionType;
  downgradeModalPrivileges?: string;
  autoRenewalTermsCondition?: TermsConditionType;
  eKitTermsCondition?: TermsConditionType;
}

interface ProgressiveProfileDataType {
  title?: string;
  icons: IconReturnType;
}

interface IconReturnType {
  registration: IconDataReturnType;
  personaldetails?: IconDataReturnType;
  esignature?: IconDataReturnType;
  order?: IconDataReturnType;
}
interface IconDataReturnType {
  iconName: string;
  url: string;
  status: boolean;
}

interface ImageReturnType {
  url: string;
  altText: string;
  viewport: string[];
}

interface ICms {
  uid?: string;
  title: string;
  find_out_more_image: {
    images: ImageCMSType[];
  };
  find_out_more_description: string;
}

export interface Result {
  find_out_more_description: string;
  title: string;
  find_out_more_image: {
    images: ImageCMSType[];
  };
}

// ContentStack Response
interface ProfileImagesResult {
  uid?: string;
  title?: string;
  locale?: string;
  sign_up_customer?: CMSResponseImagesType;
  sign_up_abo?: CMSResponseImagesType;
  profile_completed?: CMSResponseImagesType;
  profile_completed_title?: string;
  profile_completed_sub_title?: string;
  profile_completed_description?: string;
  find_out_more?: CMSResponseImagesType;
  find_out_more_title?: string;
  find_out_more_description?: string;
  no_record?: CMSResponseImagesType;
  international_sponsor_tnc1?: string;
  international_sponsor_tnc2?: string;
  google_icon?: CMSResponseImagesType;
  facebook_icon?: CMSResponseImagesType;
  id_verification_step_image_th?: CMSResponseImagesType;
  idstep_desktop_image?: CMSResponseImagesType;
  passport_loading?: CMSResponseImagesType;
  personal_details_desktop_image?: CMSResponseImagesType;
  sample_cid?: CMSResponseImagesType;
  sample_passport?: CMSResponseImagesType;
  cid_loading?: CMSResponseImagesType;
  coapp?: CoAppResponseType;
  account_card_image?: CMSResponseImagesType;
  account_upgrade_image?: CMSResponseImagesType;
}
interface TermsConditionResult {
  uid?: string;
  title?: string;
  locale?: string;
  find_out_more_page_details: TermsConditionType;
  terms_and_conditions: TermsConditionType;
  landing_page_details: LandingPageDetailsType;
  account_type?: { account_type?: string };
  publish_details?: PublishDetailsType;
}
interface AccountTypeImagesResult {
  uid?: string;
  title?: string;
  locale?: string;
  findout_more_image: CMSResponseImagesType;
  id_verification_image_desktop: CMSResponseImagesType;
  landing_page_image: CMSResponseImagesType;
  personal_details_desktop_image: CMSResponseImagesType;
  user_account?: { account_type?: string };
  publish_details?: PublishDetailsType;
}

interface AccountLifeCycleResult {
  uid?: string;
  title?: string;
  locale?: string;
  renewal_card_image?: CMSResponseImagesType;
  upgrade_screen_image?: CMSResponseImagesType;
  upgrade_screen_desktop_image?: CMSResponseImagesType;
  renewal_terms_conditions?: TermsConditionType;
  upgrade_terms_and_conditions?: TermsConditionType;
  downgrade_terms_and_conditions?: TermsConditionType;
  downgrade_modal_privileges?: TermsConditionType;
  auto_renewal_terms_and_conditions?: TermsConditionType;
  ekit_terms_and_conditions?: TermsConditionType;
}
interface ProgressiveProfileResult {
  uid?: string;
  title?: string;
  icon_details: IconCMSType[];
}

interface IconCMSType {
  icon: IconType;
  task_name: string;
  status: boolean;
}
interface IconType {
  text: string;
  url: string;
}
interface ImageCMSType {
  image: Image;
  alt_text: string;
  viewport: string[];
}

interface Image {
  url: string;
}

interface CMSResponseImagesType {
  images: ImageCMSType[];
}

interface LandingPageDetailsType {
  details: string;
}
interface CoAppResponseType {
  coapp_completed_image?: CMSResponseImagesType;
  coapp_landing_image?: CMSResponseImagesType;
  coapp_pending_image?: CMSResponseImagesType;
  coapp_registration_image?: CMSResponseImagesType;
  coapp_marriage_cert?: CMSResponseImagesType;
  coapp_tnc?: string;
}

interface CoAppFormattedType {
  completedImage: ImageReturnType;
  landingImage: ImageReturnType;
  pendingImage: ImageReturnType;
  registrationImage: ImageReturnType;
  marriageCertImage: ImageReturnType;
  coappRegistrationImage?: ImageCMSType[];
  tnc?: string;
}

// From Cart
interface CartCmsDataType {
  kit_terms_and_conditions?: TermsConditionType;
}
// tranformer to support multiple versions

const parseString = (value: DynamicObjectInterface): string => value ?? '';

export const getFindOutMoreTransformer = (result: Result): GetFindOutMoreData => {
  const { title, find_out_more_image, find_out_more_description } = result;

  const { images } = find_out_more_image;
  const [firstImage] = images;
  const { image, viewport, alt_text } = firstImage;

  const formatGetFindOutMore: GetFindOutMoreData = {
    title: title,
    image: {
      url: image.url,
      viewport: viewport,
      altText: alt_text,
    },
    findOutMoreDescription: find_out_more_description,
  };
  return formatGetFindOutMore;
};

export const getCmsDataTransformer = (result: ICms): CmsDataProps => {
  const findOutMore = getFindOutMoreTransformer(result) ?? {
    title: '',
    image: {
      url: '',
      altText: '',
      viewport: [],
    },
    findOutMoreDescription: '',
  };

  return { findOutMore };
};

// for ProfileImages
const getImageData = (image?: ImageCMSType): ImageReturnType =>
  image
    ? {
        url: image.image.url,
        viewport: image.viewport,
        altText: image.alt_text,
      }
    : emptyCMSImage;

export const emptyCMSImage: ImageReturnType = { url: '', altText: '', viewport: [] };

export const getProfileImagesTransformer = (result: ProfileImagesResult): ProfileImagesDataType => {
  // for Co App
  const formattedCoApp: CoAppFormattedType = {
    landingImage: getImageData(result?.coapp?.coapp_landing_image?.images[0]),
    pendingImage: getImageData(result?.coapp?.coapp_pending_image?.images[0]),
    completedImage: getImageData(result?.coapp?.coapp_completed_image?.images[0]),
    registrationImage: getImageData(result?.coapp?.coapp_registration_image?.images[0]),
    marriageCertImage: getImageData(result?.coapp?.coapp_marriage_cert?.images[0]),
    tnc: result?.coapp?.coapp_tnc,
    coappRegistrationImage: result?.coapp?.coapp_registration_image?.images,
  };

  const formattedRecord: ProfileImagesDataType = {
    title: result?.title,
    locale: result?.locale,
    signUpCustomer: {
      customerImage: getImageData(result?.sign_up_customer?.images[0]),
      ABOImage: getImageData(result?.sign_up_abo?.images[0]),
    },
    profileComplete: {
      image: getImageData(result?.profile_completed?.images[0]),
      title: result?.profile_completed_title ?? '',
      subTitle: result?.profile_completed_sub_title ?? '',
      desc: result?.profile_completed_description ?? '',
    },
    selectSponsor: {
      internationalSponsorTnc1: result?.international_sponsor_tnc1 ?? '',
      internationalSponsorTnc2: result?.international_sponsor_tnc2 ?? '',
    },
    passportLoading: getImageData(result?.passport_loading?.images[0]),
    personalDetailsDesktopImage: getImageData(result?.personal_details_desktop_image?.images[0]),
    sampleCid: getImageData(result?.sample_cid?.images[0]),
    sampleCidBack: getImageData(result?.sample_cid?.images?.[1]),
    samplePassport: getImageData(result?.sample_passport?.images[0]),
    cidLoading: getImageData(result?.cid_loading?.images[0]),

    noRecordImage: getImageData(result?.no_record?.images[0]),
    googleIcon: getImageData(result?.google_icon?.images[0]),
    facebookIcon: getImageData(result?.facebook_icon?.images[0]),
    coApp: formattedCoApp,

    // Account Lifecycle
    accountCardImage: getImageData(result?.account_card_image?.images[0]),
    accountUpgradeImage: getImageData(result?.account_upgrade_image?.images[0]),
  };

  return formattedRecord;
};

export const getTermsConditionTransformer = (result: TermsConditionResult): RegistrationTermsConditionType => {
  const formattedRecord: RegistrationTermsConditionType = {
    locale: result?.locale,
    termsAndConditions: result?.terms_and_conditions?.description,
    landingPageDetails: result?.landing_page_details?.details,
    findoutMorePageDetails: result?.find_out_more_page_details?.description,
  };

  return formattedRecord;
};

export const profileStepperTransformer = (result: ImageCMSType[]): ImageReturnType[] => {
  const image = result.map((image) => getImageData(image));
  return image;
};

export const getAccountTypeImagesTransformer = (result: AccountTypeImagesResult): AccountTypeImagesType => {
  const formattedRecord: AccountTypeImagesType = {
    locale: result?.locale,
    landingPageImage: result?.landing_page_image?.images?.map((item) => getImageData(item)),
    idVerificationImage: result?.id_verification_image_desktop?.images?.map((item) => getImageData(item)),
    findoutMoreImage: result?.findout_more_image?.images?.map((item) => getImageData(item)),
    personalDetailsImage: getImageData(result?.personal_details_desktop_image?.images[0]),
  };

  return formattedRecord;
};

export const getAccountLifeCycleTransformer = (result: AccountLifeCycleResult): AccountLifeCycleCMSType => {
  const formattedRecord: AccountLifeCycleCMSType = {
    title: result?.title ?? '',
    locale: result?.locale,
    renewalCardImage: getImageData(result?.renewal_card_image?.images[0]),
    upgradeScreenImage: getImageData(result?.upgrade_screen_image?.images[0]),
    upgradeDesktopImage: getImageData(result?.upgrade_screen_desktop_image?.images[0]),
    renewalTermsCondition: {
      title: parseString(result?.renewal_terms_conditions?.title),
      description: parseString(result?.renewal_terms_conditions?.description),
    },
    upgradeTermsCondition: {
      title: parseString(result?.upgrade_terms_and_conditions?.title),
      description: parseString(result?.upgrade_terms_and_conditions?.description),
    },
    downgradeTermsCondition: {
      title: parseString(result?.downgrade_terms_and_conditions?.title),
      description: parseString(result?.downgrade_terms_and_conditions?.description),
    },
    downgradeModalPrivileges: parseString(result?.downgrade_modal_privileges?.description),
    autoRenewalTermsCondition: {
      title: parseString(result?.auto_renewal_terms_and_conditions?.title),
      description: parseString(result?.auto_renewal_terms_and_conditions?.description),
    },
    eKitTermsCondition: {
      title: parseString(result?.ekit_terms_and_conditions?.title),
      description: parseString(result?.ekit_terms_and_conditions?.description),
    },
  };

  return formattedRecord;
};

const emptyTaskIcon: IconDataReturnType = {
  iconName: '',
  url: '',
  status: true,
};

const emptyTasksIconData: IconReturnType = {
  registration: emptyTaskIcon,
  personaldetails: emptyTaskIcon,
  esignature: emptyTaskIcon,
  order: emptyTaskIcon,
};

export const getProgressiveProfileTransformer = (result: ProgressiveProfileResult): ProgressiveProfileDataType => {
  const formattedRecord: ProgressiveProfileDataType = {
    title: result?.title ?? '',
    icons: emptyTasksIconData,
  };

  result?.icon_details?.forEach((item) => {
    const taskName: string = item.task_name.toLowerCase();

    if (taskName in formattedRecord.icons) {
      const iconKey = taskName as keyof IconReturnType;
      formattedRecord.icons[iconKey] = {
        iconName: item.icon.text,
        url: item.icon.url,
        status: item.status,
      };
    }
  });

  return formattedRecord;
};

export const getProfileImagesCmsDataTransformer = (result: ProfileImagesResult): ProfileImagesCMSDataProps => {
  const data = getProfileImagesTransformer(result);
  return { data };
};
export const getProfileStepperImageCmsDataTransformer = (result: ImageCMSType[]): ProfileStepperCMSDataProps => {
  const data = profileStepperTransformer(result);
  return { data };
};
export const getTermsConditionCmsDataTransformer = (result: TermsConditionResult): TermsConditionsCMSDataProps => {
  const data = getTermsConditionTransformer(result);
  return { data };
};
export const getProgressiveProfileCmsDataTransformer = (
  result: ProgressiveProfileResult,
): ProgressiveProfileCMSDataProps => {
  const data = getProgressiveProfileTransformer(result);
  return { data };
};
export const getAccountTypeImagesCmsDataTransformer = (
  result: AccountTypeImagesResult,
): AccountTypeImagesCMSDataProps => {
  const data = getAccountTypeImagesTransformer(result);
  return { data };
};
export const getAccountLifeCycleCmsDataTransformer = (result: AccountLifeCycleResult): AccountLifeCycleCMSDataProps => {
  const data = getAccountLifeCycleTransformer(result);
  return { data };
};
interface CmsDataProps {
  findOutMore: GetFindOutMoreData;
}

interface ProfileImagesCMSDataProps {
  data: ProfileImagesDataType;
}
interface TermsConditionsCMSDataProps {
  data: RegistrationTermsConditionType;
}
interface TermsConditionsCMSProps {
  data: RegistrationTermsConditionType[];
}
interface AccountTypeImagesCMSDataProps {
  data: AccountTypeImagesType;
}
interface ProgressiveProfileCMSDataProps {
  data: ProgressiveProfileDataType;
}
interface ProfileStepperCMSDataProps {
  data: ImageReturnType[];
}
interface AccountLifeCycleCMSDataProps {
  data: AccountLifeCycleCMSType;
}
export default {
  getFindOutMoreTransformer,
  getCmsDataTransformer,
  getProfileImagesTransformer,
  getProfileImagesCmsDataTransformer,
  getTermsConditionCmsDataTransformer,
  getProgressiveProfileTransformer,
  getProgressiveProfileCmsDataTransformer,
  getProfileStepperImageCmsDataTransformer,
  getTermsConditionTransformer,
  getAccountTypeImagesCmsDataTransformer,
  getAccountTypeImagesTransformer,
  getAccountLifeCycleCmsDataTransformer,
};
export type {
  ICms,
  CmsDataProps,
  ProfileImagesResult,
  TermsConditionResult,
  ProfileImagesCMSDataProps,
  ImageCMSType,
  ProfileImagesDataType,
  ImageReturnType,
  ProgressiveProfileDataType,
  ProgressiveProfileCMSDataProps,
  ProgressiveProfileResult,
  ProfileStepperCMSDataProps,
  CoAppFormattedType,
  RegistrationTermsConditionType,
  AccountTypeImagesType,
  TermsConditionsCMSDataProps,
  AccountTypeImagesResult,
  AccountTypeImagesCMSDataProps,
  AccountLifeCycleCMSDataProps,
  AccountLifeCycleCMSType,
  AccountLifeCycleResult,
  TermsConditionType,
  CartCmsDataType,
  TermsConditionsCMSProps,
};
